"use client";

import { MessageSquare, ChartLine, Compass, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  id: "01",
  title: "Submit Your Info",
  icon: MessageSquare
}, {
  id: "02",
  title: "Review & Analysis",
  icon: ChartLine
}, {
  id: "03",
  title: "Expert Guidance",
  icon: Compass
}, {
  id: "04",
  title: "Next Steps",
  icon: ShieldCheck
}];
export default function ThePathToFinancialClarity() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="141225" id="your-path-to-freedom" className="dark bg-background text-foreground py-24 lg:py-32 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-secondary/5 blur-[120px] rounded-full pointer-events-none z-0" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div ref={ref} className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-6 font-default">
            Our Simple Process
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            A methodical, transparent approach to resolving your timeshare challenges and securing your financial freedom.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-16 md:gap-8 relative">
          {steps.map((step, i) => <div key={step.id} data-index={i} className={`relative flex flex-col items-center text-center group transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              {i !== steps.length - 1 && <div className="hidden md:block absolute top-[27px] left-[50%] w-full h-px border-t-2 border-dashed border-secondary/20 z-0" />}

              {}
              {i !== steps.length - 1 && <div className="md:hidden absolute top-[56px] bottom-[-64px] left-[50%] w-px border-l-2 border-dashed border-secondary/20 z-0" />}

              {}
              <div className="w-14 h-14 rounded-full bg-card border border-border flex items-center justify-center relative z-10 mb-8 shadow-sm group-hover:border-secondary/50 group-hover:shadow-md group-hover:shadow-secondary/10 transition-all duration-300">
                <step.icon className="w-6 h-6 text-secondary" />
              </div>

              {}
              <div className="relative w-full py-2 flex flex-col items-center justify-center">
                <div className="absolute inset-0 flex items-center justify-center z-0 pointer-events-none">
                  <span className="text-7xl md:text-8xl font-black text-secondary/10 tracking-tighter group-hover:text-secondary/20 transition-colors duration-300">
                    {step.id}
                  </span>
                </div>
                <h3 className="text-xl font-semibold text-foreground relative z-10 font-default">
                  {step.title}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}